import { MarkerDataSystem } from "api/interfaces/dashboardInterface.interface";
import styled from "styled-components";
import { ALERT_CHART_COLORS } from "styles/colors";
import SendAssignee from "pages/alert/view/components/SendAssignee";
import { useQueryClient } from "react-query";
import { FLEX } from "styles/flex";

type AssigneeInfoType = {
  recorder: MarkerDataSystem;
};

export const AssigneeInfo = ({ recorder }: AssigneeInfoType): JSX.Element => {
  const assignee = recorder.isAssignee;
  const queryClient = useQueryClient();
  if (!assignee) {
    return <></>;
  }

  return (
    <Container>
      <SendAssignee
        assignee={assignee.assigneeName || ""}
        assigneeId={assignee.assigneeId || ""}
        assigneePhone={assignee.assigneePhone || ""}
        assigneeMail={assignee.assigneeEmail || ""}
        notifySms={assignee.notifySms || false}
        refetch={() => {
          queryClient.invalidateQueries("searchMapFilterResult");
        }}
        recorderId={recorder.recorderId}
      />
    </Container>
  );
};

const Container = styled.span`
  ${FLEX.FlexBetweenCenter};
  width: 100%;
  width: 100%;
  color: ${ALERT_CHART_COLORS.ASSIGNED};
  .assignee-button-wrapper {
    ${FLEX.FlexEndCenter};
    gap: 8px;
    button {
      color: ${ALERT_CHART_COLORS.ASSIGNED};
      cursor: pointer;
    }
  }
`;
